import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  HeadTableCell,
  RowTableCell,
  CustomButton,
  GeneralTableBox,
  PaginationTable,
  DialogBody,
  SearchBar,
  ActionIconButton,
} from '../../../common/components';

import PostAddIcon from '@mui/icons-material/PostAdd';

import ConstructionTypeDialog from '../dialogs/ConstructionTypeDialog';
import { usePaginatedFilter } from '../../../common/hooks/usePaginatedFilter';
import { formatNumber } from '../../../utils/formatUtils';

const ITEMS_PER_PAGE = 5;

const filterConstructionTypes = (collection = [], term = '') => {
  if (!term?.trim()) return collection;
  const normalized = term.toLowerCase().trim();
  return collection.filter((type) => type.name?.toLowerCase().includes(normalized));
};

const ConstructionTypesTab = ({
  data,
  selectedItem,
  dialogOpen,
  editMode,
  handleAdd,
  handleEdit,
  handleDelete,
  handleClose,
  handleSave,
}) => {
  const {
    data: paginatedConstructionTypes,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
  } = usePaginatedFilter({
    data,
    itemsPerPage: ITEMS_PER_PAGE,
    filterFn: filterConstructionTypes,
  });

  return (
    <DialogBody sx={{ p: 2, minHeight: '65vh' }}>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <CustomButton variant="contained" onClick={handleAdd}>
            <PostAddIcon sx={{ mr: 1 }} />
            Agregar
          </CustomButton>
          <SearchBar onSearch={handleSearch} />
        </Box>

        <GeneralTableBox>
          <Table>
            <TableHead>
              <TableRow>
                <HeadTableCell>Tipo</HeadTableCell>
                <HeadTableCell>Superficie (m²)</HeadTableCell>
                <HeadTableCell>Descripción</HeadTableCell>
                <HeadTableCell>Acciones</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedConstructionTypes.map((type, index) => (
                <TableRow key={type.id || index}>
                  <RowTableCell>{type.name}</RowTableCell>
                  <RowTableCell>
                    {formatNumber(type.surface, { decimals: 0, fallback: '-' })}
                  </RowTableCell>
                  <RowTableCell>{type.description || '-'}</RowTableCell>
                  <RowTableCell>
                    <ActionIconButton variant="edit" onClick={() => handleEdit(type)} />
                    <ActionIconButton variant="delete" onClick={() => handleDelete(type.uuid)} />
                  </RowTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {totalCount > rowsPerPage && (
            <PaginationTable
              totalPages={totalPages}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              totalCount={totalCount}
            />
          )}
        </GeneralTableBox>
      </Box>

      <ConstructionTypeDialog
        open={dialogOpen}
        onClose={handleClose}
        onSave={handleSave}
        selectedItem={selectedItem}
        editMode={editMode}
      />
    </DialogBody>
  );
};

export default ConstructionTypesTab;
